Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable import/prefer-default-export */
var CHANNEL = exports.CHANNEL = 'loggingContext';


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-with-tracking/build/constants.js
// module id = 481
// module chunks = 168707334958949